interface IAdminUserRoles {
  admin: string;
  general: string;
  onlyProperty: string;
}

export const AdminUserRoles: IAdminUserRoles = {
  admin: "admin",
  general: "general",
  onlyProperty: "only_property",
};

export enum AdminUserRoleNumber {
  admin = 0,
  general = 1,
  only_property = 2,
}
